/*jshint esversion: 6 */
import Swiper from 'swiper';
import { trackIndustriesCardClick } from '../analytics';

const PostGrid = (function($) {

  const _s = {
    container: '.wp-block-indp-post-grid',
    grid: '.wp-block-indp-post-grid__grid',
    item: '.wp-block-indp-post-grid__item',
    link: '.wp-block-indp-post-grid__link',
    breakpoint: 782
  };

  let swiperInstances = new Map();

  const _init = function() {
    if ($(_s.container).length === 0) {
      return;
    }

    _handleSwiper();
    _bindEvents();
    _trackIndustryClicks();
  };

  // ===================
  // Handle Swiper Init/Destroy based on viewport
  const _handleSwiper = function() {
    const grids = document.querySelectorAll(_s.grid);
    
    grids.forEach((grid) => {
      if (window.innerWidth < _s.breakpoint) {
        _initSwiper(grid);
      } else {
        _destroySwiper(grid);
      }
    });
  };

  // ===================
  // Initialize Swiper
  const _initSwiper = function(grid) {
    // Don't initialize if already initialized
    if (swiperInstances.has(grid)) {
      return;
    }

    // Wrap grid in a swiper container
    const swiperContainer = document.createElement('div');
    swiperContainer.className = 'swiper';
    grid.parentNode.insertBefore(swiperContainer, grid);
    swiperContainer.appendChild(grid);
    
    // Add Swiper wrapper class to grid
    grid.classList.add('swiper-wrapper');
    
    const items = grid.querySelectorAll(_s.item);
    items.forEach(item => {
      item.classList.add('swiper-slide');
    });

    // Initialize Swiper on the container
    const swiper = new Swiper(swiperContainer, {
      slidesPerView: 1.2,
      spaceBetween: 20,
      centeredSlides: false,
      loop: false,
      breakpoints: {
        480: {
          slidesPerView: 1.5,
          spaceBetween: 20,
        },
        640: {
          slidesPerView: 2.2,
          spaceBetween: 25,
        },
        782: {
          slidesPerView: 2,
          spaceBetween: 25,
        },
        1100: {
          slidesPerView: 3,
          spaceBetween: 25,
        }
      }
    });
    
    swiperInstances.set(grid, swiper);
  };

  // ===================
  // Destroy Swiper
  const _destroySwiper = function(grid) {
    const swiper = swiperInstances.get(grid);
    
    if (swiper) {
      const swiperContainer = swiper.el;
      const parent = swiperContainer.parentNode;
      
      // Destroy swiper instance
      swiper.destroy(true, true);
      swiperInstances.delete(grid);
      
      // Unwrap: move grid back to parent and remove container
      parent.insertBefore(grid, swiperContainer);
      swiperContainer.remove();
    }

    // Remove Swiper classes
    grid.classList.remove('swiper-wrapper');
    
    const items = grid.querySelectorAll(_s.item);
    items.forEach(item => {
      item.classList.remove('swiper-slide');
    });
  };

  // ===================
  // Bind Events
  const _bindEvents = function() {
    let resizeTimer;
    
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        _handleSwiper();
      }, 250);
    });
  };

  // ===================
  // Track Industry Card Clicks (Home Page Only)
  const _trackIndustryClicks = function() {
    // Check if we're on the home page
    const isHomePage = $('body').hasClass('home') || $('body').hasClass('page-template-default');
    
    if (!isHomePage) {
      return;
    }

    // Track post grid link clicks on home page
    $(document).on('click', _s.link, function() {
      const $link = $(this);
      const $item = $link.closest(_s.item);
      const cardUrl = $link.attr('href');
      const cardTitle = $link.find('.wp-block-indp-post-grid__title').text().trim();
      const cardType = $item.data('post-type') || 'industry';
      
      if (cardUrl && cardTitle) {
        trackIndustriesCardClick(cardTitle, cardUrl, cardType);
      }
    });
  };

  return {
    container: _s.container,
    init: _init
  };

})(jQuery);

export default PostGrid;
